/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API48553Req {
  
  /** 项目编号 */
  projectNo?: string;
    
  /** 汇报编号 */
  reportNo?: string;
    
};



export interface API48553Res {
  /** 项目编号  */
  projectNo?: string;
  /** 汇报编号  */
  reportNo?: string;
  /** 汇报日期  */
  reportDate?: any;
  /** 内容  */
  content?: string;
  /** 创建者  */
  creator?: string;
  /** 创建者名称  */
  creatorName?: string;
  /** 修改者  */
  updater?: string;
  /** 修改者名称  */
  updaterName?: string;
  /** 健康标志：0-10  */
  healthFlag?: number;
  /** 项目进度（61.23%存6123）  */
  projectProgress?: number;
  /** 项目进度,double值，61.23  */
  projectProgressDou?: any;
  /** 项目进度，描述值：61.23%  */
  projectProgressDesc?: string;
  /** 是否可查看  */
  read?: boolean;
  /** 是否可编辑  */
  edit?: boolean;
  /** 是否可删除  */
  delete?: boolean;
  /** 是否可下载  */
  download?: boolean;
  
};


// 48553 汇报详情

export interface IUseGetAPI48553Return {
  /** 汇报详情: 接口请求状态 */
  isAPI48553Loading: boolean;
  /** 汇报详情: 接口请求返回数据 */
  dataAPI48553: API48553Res;
  /**  汇报详情: 接口数据请求方法 */
  fetchAPI48553Data:  (inputs: API48553Req, config?: YWRequestConfig) => Promise<API48553Res>;
  /** 汇报详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48553 = ():IUseGetAPI48553Return => {
  let isMount = true;
  const [isAPI48553Loading, setIsAPI48553Loading] = useState(false);
  const [dataAPI48553, setDataAPI48553] = useState<API48553Res>({} as API48553Res);
  const requestUrl = `${basePath}/corp-admin/project/report/detail`;

  const fetchAPI48553Data = async (inputs: API48553Req, config?: YWRequestConfig): Promise<API48553Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48553Req>) || {}) as API48553Req;
    
  
    if ( isMount ) {
      setIsAPI48553Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48553Res>(`${basePath}/corp-admin/project/report/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48553(res || {} as API48553Res);
        setIsAPI48553Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48553Loading(false);
      }
      return false as unknown as API48553Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48553Loading,
    dataAPI48553,
    fetchAPI48553Data,
    requestUrl,
  }
}

